import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import Linkify from 'react-linkify';
import {
    Accordion,
    AccordionItem,
    AccordionItemHeading,
    AccordionItemButton,
    AccordionItemPanel,
} from 'react-accessible-accordion';

const AccordionWrapper = styled.div`
  position: relative;
  width: calc(100% - 24px);
  max-width: 1200px;
  margin: auto;
  padding: 30px 0;
`;

const StyledAccordionItem = styled(AccordionItem)`
  margin-bottom: 2px;
`;

const AccordionQuestion = styled.div`
  position: relative;
  background-color: ${props => props.theme.colors.primary};
  color: black;
  padding: 14px 30px;
  font-size: 16px;
  cursor: pointer;

  &::after {
    position: absolute;
    display: block;
    content: '+';
    right: 14px;
    top: 50%;
    margin-top: -8px;
    
    ${props => !!props.selected && css`
      content: '-';
    `}
  }
`;

const AccordionAnswer = styled.div`
  color: ${props => props.theme.colors.primary};
  background-color: black;
  padding: 40px 30px;
  line-height: 1.5;

  a {
    color: ${props => props.theme.colors.primary};
  }
`;

const AccordionTool = ({ faqData }) => {
  const [isInitial, setInitial] = useState(false);
  const [faqIndex, setFaqIndex] = useState(0);


  return (
    <AccordionWrapper>
      <Accordion
        onChange={arr => {
          setFaqIndex(arr[0]);
          if(!isInitial) {
            setInitial(true);
          }
        }}
        allowZeroExpanded
      >
        {Array.isArray(faqData) && faqData.map((item, index) => (
          <StyledAccordionItem key={index}>
            <AccordionItemHeading>
              <AccordionItemButton>
                <AccordionQuestion className={!!isInitial && faqIndex === index ? '' : 'faq-question'} selected={!!isInitial && faqIndex === index}>{item.question}</AccordionQuestion>
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel>
              <AccordionAnswer>
                <Linkify properties={{ target: '_blank' }}>
                  {item.answer.split('\n').map(function(item, idx) {
                      return (
                          <span key={idx}>
                              {item}
                              <br/>
                          </span>
                      )
                  })}
                </Linkify>
              </AccordionAnswer>
            </AccordionItemPanel>
          </StyledAccordionItem>
        ))}
      </Accordion>
    </AccordionWrapper>
  )
}

export default AccordionTool;